import axios from 'axios';

export function openDemoModal() {
    console.log('open modal');
    document.querySelector('.get_demo')?.click();
  }
  
  export function getTranslations(filePath) {
    return new Promise((resolve, reject) => {
        const rawFile = new XMLHttpRequest();
        rawFile.overrideMimeType('application/json');
        rawFile.open('GET', filePath, true);
        rawFile.onreadystatechange = () => {
            if (rawFile.readyState !== 4 || rawFile.status !== 200) return;
    
            resolve(JSON.parse(rawFile.responseText));
        }
        rawFile.error = err => reject(err);
        rawFile.send(null);
    });
  }
  
  export function getPrices() {
    return axios
      .get('https://bank.gov.ua/NBUStatService/v1/statdirectory/exchange?json')
      .then(({ data }) => data)
      .catch(err => { throw err; });
  }